import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change, destroy } from 'redux-form';
import { Grid, Modal, Button, Icon, Select } from 'semantic-ui-react';
import _ from 'lodash';

import { ReportGeneration } from 'Common/ObjectHelper';
import { toastError, toastInfo } from 'Common/ToastHelper';
import { makeOptionsData, numericSort } from 'Common/FormHelper';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { saveCycleMenu } from 'Pages/managemenu/state/editmenu/actions';
import { TitledCard } from 'Components';
import { getReport, clearReport } from 'State/report/actions';
import {
  getReportData,
  getReportError,
  getReportFetching,
} from 'State/report/selectors';

import 'Styles/pages/managemenu/manageMenuModal.less';

class AnalysisReportModal extends Component {
  static propTypes = {
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
    headerTitle: PropTypes.string.isRequired,
    numberOfDays: PropTypes.number.isRequired,
    menuId: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    const startDayOptions = [...new Array(props.numberOfDays)].map((_, i) => ({
      Id: i + 1,
      Description: i + 1,
    }));

    const daysOptions = [...new Array(5)].map((_, i) => ({
      Id: i + 3,
      Description: i + 3,
    }));

    this.state = {
      startDay: _.get(startDayOptions, '[0].Id', 1),
      startDayOptions: makeOptionsData(startDayOptions, undefined, numericSort),
      days: daysOptions[0].Id,
      daysOptions: makeOptionsData(daysOptions, undefined, numericSort),
      saving: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { report, error, clearReport } = this.props;

    if (!prevProps.error && error) {
      toastError(error.Message || error.Title);
    }

    if (report !== null && report !== prevProps.report) {
      if (report === '') {
        toastInfo('No data found!');
      } else {
        ReportGeneration(report, 'Food Based Analysis Report');
      }

      clearReport();
    }
  }

  onSelect = key => (e, data) => {
    const { value } = data;
    this.setState({ [key]: value });
  };

  validate() {
    const { days } = this.state;
    let valid = false;

    if (days > 2) {
      valid = true;
    }

    return valid;
  }

  getReport = async () => {
    const isValid = this.validate();

    if (!isValid) {
      return;
    }

    const { saveCycleMenu, menuId, getReport, isReadOnly } = this.props;
    const { startDay, days } = this.state;

    const data = {
      cycleMenuId: menuId,
      startDay,
      analysisDays: days,
    };
    if (isReadOnly) {
      getReport('Reports/FoodBasedAnalysisReport', data);
    } else {
      this.setState({ saving: true });
      const saved = await saveCycleMenu();

      if (saved) {
        getReport('Reports/FoodBasedAnalysisReport', data);
      }
      this.setState({ saving: false });
    }
  };

  render() {
    const { headerTitle, modalProps, fetching } = this.props;

    const { startDay, startDayOptions, days, daysOptions, saving } = this.state;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header ">
          {headerTitle}
          <Icon
            className="cursor-pointer"
            name="close"
            onClick={modalProps.onClose}
          />
        </Modal.Header>

        <Modal.Content className="manage-menu-modal-content">
          <TitledCard title="Analysis Report">
            <Grid padded>
              <Grid.Row>
                <Grid.Column width="4">
                  <span className="text-orange">Start on Day:</span>
                  <Select
                    options={startDayOptions}
                    fluid
                    onChange={this.onSelect('startDay')}
                    value={startDay}
                  />
                </Grid.Column>
                <Grid.Column width="4">
                  <span className="text-orange">How Many Days?</span>
                  <Select
                    options={daysOptions}
                    fluid
                    onChange={this.onSelect('days')}
                    value={days}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.getReport}
            loading={fetching || saving}
            className="mnm-button-blue"
            disabled={fetching || saving}
          >
            View Report
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  report: getReportData(state),
  error: getReportError(state),
  fetching: getReportFetching(state),
});

const mapDispatchToProps = {
  setNotificationDialog,
  saveCycleMenu,
  change,
  destroy,
  getReport,
  clearReport,
  toastError,
};

const ConnectedAnalysisReportModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalysisReportModal);

export { ConnectedAnalysisReportModal as AnalysisReportModal };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/AnalysisReportModal.js